import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import { fileTransferUrls } from "./fileTransferUtils";
import { apiUrls } from "../../library/Utils";
import { saveAs } from "file-saver";

export const GetUserCountries = createAsyncThunk(
  "fileTransfer/GetUserCountries",
  async (obj) => {
    let reqOptions = {};
    const data = JSON.parse(localStorage.getItem("data"));
    reqOptions.method = obj.method;
    let url = apiUrls.countryListUrl + data.userID;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);

export const GetFolderIdByName = createAsyncThunk(
  "fileTransfer/GetFolderIdByName",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url =
      fileTransferUrls.getFolderIdByName + "FolderName=" + obj.FolderName;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("fileTransfer/GetFolderIdByName Error: ", error);
    }
  }
);

export const GetFolderContent = createAsyncThunk(
  "fileTransfer/GetFolderContent",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = fileTransferUrls.getFolderContent + "id=" + obj.id;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData.items;
    } catch (error) {
      console.error("fileTransfer/GetFolderContent Error: ", error);
    }
  }
);

export const DownloadFile = createAsyncThunk(
  "fileTransfer/DownloadFile",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = fileTransferUrls.downloadFile + "fileId=" + obj.fileId;

    try {
      const response = await fetch(url, {
        method: obj.method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const res = await response.blob();
      const fileName = obj.fileName;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("fileTransfer/DownloadFile Error: ", error);
    }
  }
);

export const UploadFile = createAsyncThunk(
  "fileTransfer/UploadFile",
  async (obj) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = fileTransferUrls.uploadFile;

      let formData = new FormData();
      formData.append("filePath", obj.filePath);
      formData.append("folderId", obj.folderId);
      formData.append(
        "files",
        obj.fileObj,
        obj.fileName + "." + obj.fileExtension
      );

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Disposition": "multipart/form-data",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: formData,
      });

      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("fileTransfer/UploadFile Error", error);
    }
  }
);

export const DeleteFile = createAsyncThunk(
  "fileTransfer/DeleteFile",
  async (obj) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = fileTransferUrls.deleteFile + "fileId=" + obj.fileId;

      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("fileTransfer/DeleteFile Error", error);
    }
  }
);

export const ProcessFile = createAsyncThunk(
  "fileTransfer/ProcessFile",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = fileTransferUrls.processFile;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });

      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("fileTransfer/ProcessFile Error: ", error);
    }
  }
);

const initialState = {
  isLoading: false,
  isSuccess: false,
  isSuccess_Info: "",
  isFailed: false,
  isFailed_Info: "",
  isError: false,
  isAlert: false,
  isAlert_Info: "",
  countries: [],
  getFolderIdByName: "",
  getFolderContent: [],
  apiResponse: null,
};

const fileTransferSlice = createSlice({
  name: "fileTransfer",
  initialState,
  reducers: {
    setState: {
      prepare(stateName, stateValue) {
        return {
          payload: { stateName, stateValue },
        };
      },
      reducer(state, action) {
        const { stateName, stateValue } = action.payload;
        state[stateName] = stateValue;
      },
    },
    clearStatus(state, { payload }) {
      state.isSuccess = false;
      state.isSuccess_Info = false;
      state.isFailed = false;
      state.isFailed_Info = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetUserCountries.pending, (state, action) => {
        //state.isLoading = true;
      })
      .addCase(GetUserCountries.fulfilled, (state, { payload }) => {
        state.countries = payload;
        //state.isLoading = false;
      })
      .addCase(GetUserCountries.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetUserCountries", action.error.message);
      })

      .addCase(GetFolderIdByName.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetFolderIdByName.fulfilled, (state, { payload }) => {
        state.getFolderIdByName = payload;
        state.isLoading = false;
      })
      .addCase(GetFolderIdByName.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetFolderIdByName", action.error.message);
      })

      .addCase(GetFolderContent.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetFolderContent.fulfilled, (state, { payload }) => {
        state.getFolderContent = payload;
        state.isLoading = false;
      })
      .addCase(GetFolderContent.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetFolderContent", action.error.message);
      })

      .addCase(DownloadFile.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(DownloadFile.fulfilled, (state, action) => {
        state.apiResponse = action.payload;
        state.isLoading = false;
      })
      .addCase(DownloadFile.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from DownloadFile", action.error.message);
      })

      .addCase(DeleteFile.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(DeleteFile.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload == 1) {
          state.isSuccess = true;
          state.isSuccess_Info = "File deleted successfully";
        } else {
          state.isFailed = true;
          state.isFailed_Info = "Error occured in DeleteFile";
        }
      })
      .addCase(DeleteFile.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from DeleteFile", action.error.message);
      })

      .addCase(UploadFile.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(UploadFile.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload == "success") {
          state.isSuccess = true;
          state.isSuccess_Info = "File uploaded successfully";
        } else if (payload == "empty") {
          state.isSuccess = true;
          state.isSuccess_Info = "File uploaded successfully";
          state.isAlert = true;
          state.isAlert_Info = "Uploaded file contains no records";
        } else if (payload == "duplicate") {
          state.isSuccess = true;
          state.isSuccess_Info = "File uploaded successfully";
          state.isAlert = true;
          state.isAlert_Info = "Uploaded file contains duplicate records";
        } else if (payload == "emptyCell") {
          state.isSuccess = true;
          state.isSuccess_Info = "File uploaded successfully";
          state.isAlert = true;
          state.isAlert_Info =
            "In the uploaded file atleast one mandatory cell is empty";
        } else if (payload == "otherSalesOrg") {
          state.isSuccess = true;
          state.isSuccess_Info = "File uploaded successfully";
          state.isAlert = true;
          state.isAlert_Info =
            "Uploaded file contains other sales organisations";
        } else {
          state.isFailed = true;
          state.isFailed_Info = "Error occured in UploadFile";
          state.isAlert = true;
          state.isAlert_Info = payload;
        }
      })
      .addCase(UploadFile.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from UploadFile", action.error.message);
      })

      .addCase(ProcessFile.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(ProcessFile.fulfilled, (state, { payload }) => {
        if (typeof payload == "string") {
          state.isFailed = true;
          state.isFailed_Info = payload;
        } else {
          if (payload == 1) {
            state.isSuccess = true;
            state.isSuccess_Info =
              "File is processed and moved to Archived/Processed folder";
          } else {
            state.isFailed = true;
            state.isFailed_Info =
              "File is rejected and moved to Archived/Rejected folder";
          }
        }
        state.isLoading = false;
      })
      .addCase(ProcessFile.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from ProcessFile", action.error.message);
      });
  },
});

export const { setState, clearStatus } = fileTransferSlice.actions;

export default fileTransferSlice.reducer;
